import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('pageloaded', () => {
  addAnimScrollTrigger();
});

// create the smooth scroller if not on the gallery page
const body = document.querySelector('body');

export function addAnimScrollTrigger() {
  // Trigger animation active class
  const scrollTriggerEls = document.querySelectorAll('.data-scroll, .data-scroll-wrapper, .wp-block-quote');

  if(scrollTriggerEls){
    scrollTriggerEls.forEach(elem => {

      if(!elem.classList.contains('no-animation')){
        ScrollTrigger.create({
          trigger: elem,
          onEnter: function(self){
            addAnimationClass(elem);
          },
          onEnterBack: function(self){
            addAnimationClass(elem);
          }
        });
      }
    });

    window.almComplete = function(alm){
    	ScrollTrigger.refresh();
      const almPosts = document.querySelectorAll('.alm-reveal .data-scroll:not(.is-inview)');
      if(almPosts.length){
        almPosts.forEach(elem => {
          ScrollTrigger.create({
            trigger: elem,
            onEnter: function(self){
              addAnimationClass(elem);
            },
            onEnterBack: function(self){
              addAnimationClass(elem);
            }
          });
        });
      }
    };
  }
}

export function addAnimationClass(elem) {
  if(elem.classList.contains('data-scroll') || elem.classList.contains('wp-block-quote')){
    elem.classList.add('is-inview');
  }
  if(elem.classList.contains('data-scroll-wrapper')){
    elem.classList.add('in-viewport');
  }
}
